export default "__VITE_ASSET__C6ryb38h__"